const BRANDS_ENUM = {
  CARNET: 'carnet',
  ELO: 'elo',
  SODEXO: 'sodexo',
  VR: 'vr',
  MAIS: 'mais',
  HIPERCARD: 'hipercard',
  DISCOVER: 'discover',
  PAQUETA: 'paqueta',
  DINERS: 'diners',
  AMEX: 'amex',
  AURA: 'aura',
  JCB: 'jcb',
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  ALELO: 'alelo',
  UNIONPAY: 'unionpay',
  OTHERS: 'others',
  CASASHOW: 'casashow',
  HAVAN: 'havan',
  HUGCARD: 'hugCard',
  LEADERCARD: 'leaderCard',
  PERNAMBUCANAS: 'pernambucanas',
  CASAEVIDEO: 'casaevideo',
  CASSOL: 'cassol',
  KOERICH: 'koerich',
  ANDARAKI: 'andaraki',
  SUBMARINO: 'submarino',
  CREDZ: 'credz',
  SENFF: 'senff',
  CABAL: 'cabal',
  SOROCRED: 'sorocred',
  BANESCARD: 'banescard',
  CLUBMAIS: 'clubmais',
  DACASA: 'dacasa',
  CARREFOUR: 'carrefour',
  RENNER: 'renner',
  URBY: 'urby',
  TOP: 'top',
  PEFISA: 'pefisa',
  CLIQX: 'cliqx',
  TICKET: 'ticket'
}

export default BRANDS_ENUM
